'use strict';

var themeNameLight = 'light';
var themeNameDefault = themeNameLight;
var themeNames = [themeNameLight, 'light-mobile', 'light-high-contrast-experimental', 'dark-experimental'];

exports.themeNameDefault = themeNameDefault;
exports.themeNameLight = themeNameLight;
exports.themeNames = themeNames;
